export default __webpack_public_path__ + "static/media/scene_desktop.9db2e740.png";